import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { AnnouncementBanner } from '../Home/AnnouncementBanner';
interface LayoutProps {
  children: React.ReactNode;
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
  openPaymentForm?: () => void;
}
export const Layout = ({
  children,
  openRegistrationForm,
  openHostSalonForm,
  openPaymentForm
}: LayoutProps) => {
  return <div className="flex flex-col min-h-screen" data-id="element-744">
      <AnnouncementBanner data-id="element-745" />
      <div className="h-[32px]" data-id="element-746"></div>
      <Header openRegistrationForm={openRegistrationForm} openPaymentForm={openPaymentForm} data-id="element-747" />
      <main className="flex-grow pt-[76px]" data-id="element-748">{children}</main>
      <Footer openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} data-id="element-749" />
    </div>;
};